import Vue from "vue";
import VueTextareaAutogrowDirective from "vue-textarea-autogrow-directive";

Vue.use(VueTextareaAutogrowDirective);
